import ProgressBar from './Progress.component';

export default ProgressBar;
